import { Link } from 'react-router-dom';
import image from "../../assets/img/about/about-4.jpg";
import bgImage from "../../assets/img/portfolio/portfolio-8.jpg";


const AboutMain = () => {
    return (
        <>
            <div className="mission__area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="mission__area-left mr-40 xl-mr-0 text-center">
                                <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">About Us</span>
                                <h2 className="title_split_anim mb-25">Dedicated to Delivering Value and Excellence</h2>
                                <p className="wow fadeInUp" data-wow-delay=".6s">
                                    At Sukhi Construction Ltd, we believe every project deserves more than just workmanship — it deserves passion, precision, and purpose.
                                </p>
                                <p className="wow fadeInUp" data-wow-delay=".7s">
                                    From concept to completion, we deliver spaces that are functional, elegant, and built to last.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-60">
                        <div className="col-lg-6 lg-mb-25">
                            <div className="mission__area-left mr-40 xl-mr-0">
                                <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">Our Mission</span>
                                <h3 className="wow fadeInRight" data-wow-delay=".6s">To bring world-class building craftsmanship to Southall and beyond — guided by integrity, innovation, and a promise to exceed expectations.</h3>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="mission__area-right">
                                <div className="row">
                                    <div className="col-md-6 md-mb-25 wow fadeInUp" data-wow-delay=".6s">
                                        <div className="experience__area-list-item">
                                            <i className="flaticon-project"></i>
                                            <div className="experience__area-list-item-content">
                                                <h4>Project Planning</h4>
                                                <p>We ensure every detail is perfectly aligned — from design to delivery — creating structures that combine beauty with performance.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 wow fadeInUp" data-wow-delay=".9s">
                                        <div className="experience__area-list-item">
                                            <i className="flaticon-development"></i>
                                            <div className="experience__area-list-item-content">
                                                <h4>Labour Excellence</h4>
                                                <p>Our experienced professionals take pride in precision, safety, and execution — every build reflects our dedication to quality.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="about__five section-padding pt-0">
                <div className="container">
                    <div className="row al-center">
                        <div className="col-lg-5 lg-mb-25">
                            <div className="about__five-image wow img_left_animation">
                                <img src={image} alt="image" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="about__five-right ml-70 xl-ml-0">
                                <div className="about__five-right-title">
                                    <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">🧱 Trusted Partner in Construction and Design</span>
                                    <h2 className="title_split_anim">Building Trust Since 2010</h2>
                                </div>
                                <div className="features wow fadeInUp" data-wow-delay=".3s" style={{backgroundImage: `url(${bgImage})`}}>
                                    <h3>Founded by Charanjeet Singh</h3>
                                </div>
                                <p className="wow fadeInUp" data-wow-delay=".6s">Sukhi Construction has grown from a one-man vision into a trusted name with over 15 skilled experts. We've helped hundreds of homeowners and developers transform ideas into lasting spaces — blending traditional craftsmanship with modern methods.</p>
                                <p className="wow fadeInUp" data-wow-delay=".7s">We're not just builders — we're creators of lifestyle spaces, designed for comfort, safety, and long-term value.</p>
                                <div className="item_bounce">
                                    <Link className="build_button mt-20" to="/gallery">Explore Our Projects<i className="flaticon-right-up"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="about__five section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="about__five-right">
                                <div className="about__five-right-title">
                                    <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">Our Impact Areas</span>
                                    <h3 className="wow fadeInRight" data-wow-delay=".6s">Residential | Commercial | Landscaping | Renovation | Extensions | Interior Design</h3>
                                </div>
                                <p className="wow fadeInUp" data-wow-delay=".7s">
                                    From smart loft conversions and kitchen refurbishments to full-scale new builds — every project we deliver carries the Sukhi Construction stamp of reliability and refinement.
                                </p>
                                <div className="row mt-40">
                                    <div className="col-md-4 col-sm-6 mt-25 wow fadeInUp" data-wow-delay=".4s">
                                        <div className="experience__area-list-item">
                                            <i className="flaticon-home"></i>
                                            <div className="experience__area-list-item-content">
                                                <h4>Residential</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-6 mt-25 wow fadeInUp" data-wow-delay=".5s">
                                        <div className="experience__area-list-item">
                                            <i className="flaticon-project"></i>
                                            <div className="experience__area-list-item-content">
                                                <h4>Commercial</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-6 mt-25 wow fadeInUp" data-wow-delay=".6s">
                                        <div className="experience__area-list-item">
                                            <i className="flaticon-project"></i>
                                            <div className="experience__area-list-item-content">
                                                <h4>Landscaping</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-6 mt-25 wow fadeInUp" data-wow-delay=".7s">
                                        <div className="experience__area-list-item">
                                            <i className="flaticon-repair"></i>
                                            <div className="experience__area-list-item-content">
                                                <h4>Renovation</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-6 mt-25 wow fadeInUp" data-wow-delay=".8s">
                                        <div className="experience__area-list-item">
                                            <i className="flaticon-development"></i>
                                            <div className="experience__area-list-item-content">
                                                <h4>Extensions</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-6 mt-25 wow fadeInUp" data-wow-delay=".9s">
                                        <div className="experience__area-list-item">
                                            <i className="flaticon-design-thinking"></i>
                                            <div className="experience__area-list-item-content">
                                                <h4>Interior Design</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AboutMain;